import React, { useContext, useEffect } from "react";
import { Form as FormAntd, message } from "antd";
import { Layer } from "../../../../component/layer/layer";
import { Button } from "../../../../component/button";
import { ReportFormStore } from "../../store/report/report_form_store";
import { reportFormAction } from "../../action/report/report_form_action";
import { CostFormBasic } from "./cost_form_basic";
import { CostFormStore } from "../../store/cost/cost_form_store";
import { costFormAction } from "../../action/cost/cost_form_action";
import { useBoolean } from "ahooks";

interface IForm {
    children?: any;
    action: any;
    close: (hasUpdate?: boolean) => void;
    id?: string;
    numberNo?: string;
    subId: string;
    audit: boolean;
    method?: string;
    item;
}
export function Form({ close, method, id, item, audit, numberNo }: IForm) {
    const [form] = FormAntd.useForm();

    const { state, dispatch } = useContext(CostFormStore);
    const [loading, loadFunc] = useBoolean(false)
    const action = costFormAction;

    useEffect(() => {

        action.init({ state: state, dispatch, id: numberNo, form, method });

        return () => {

        }
    }, []);

    const title = () => {
        if ("Create" === method) {
            return "新增成本变更";
        }
        else if ("Edit" === method) {
            return "编辑成本变更";
        }
        else {
            return "预览成本变更";
        }
    }

    return (
        <FormAntd form={form}>
            <Layer layerWith={4} >
                <Layer.Title onClick={() => close()}>{title()}</Layer.Title>
                <Layer.Body>
                    <CostFormBasic disabled={!("Create" == method || "Edit" == method)} updateFormField={(field, value = '') => {
                        form.setFieldsValue({
                            [field]: value,
                        });
                    }} />
                </Layer.Body>
                <Layer.Foot borderStyle={title() == '预览成本变更' ? { border: 'none' } : {}}>
                    {
                        ("Create" == method || "Edit" == method) && (
                            <Button type="primary" color="Yellow" style={{ marginRight: "1.25rem" }} onClick={async () => {
                                // await form.validateFields();
                                let formV = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 2 });
                                    loadFunc.setFalse()
                                } else {
                                    loadFunc.setTrue()
                                    r = await action.updSubmit({ state, status: 2 }, id, numberNo);
                                    loadFunc.setFalse()
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存并返回
                            </Button>
                        )
                    }
                    {
                        ("Create" == method || "Edit" == method && item.status == 2) && audit && (
                            <Button type="primary" color="Red" onClick={async () => {
                                // await form.validateFields();
                                let formV = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 1 });
                                    loadFunc.setFalse()
                                } else {
                                    loadFunc.setTrue()
                                    r = await action.updSubmit({ state, status: 1 }, id, numberNo);
                                    loadFunc.setFalse()
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存并审核
                            </Button>
                        )
                    }
                </Layer.Foot>

            </Layer>
        </FormAntd>
    )
}